import { Suggestion } from 'modules/ai/nba/types/nbaQuery';

export const getSelectedSuggestion = (suggestions: Suggestion[], selectedValue: string) =>
  suggestions[parseInt(selectedValue, 10)] || {};
